import { useStore } from '@nanostores/solid'
import { Show } from 'solid-js'
import type { DayCard } from '~/lib/derive-day-cards'
import { m } from '~/paraglide/messages'
import { $isInSubscription } from '~/store/service-level'
import {
  CardHeader,
  CardShell,
  CtaOpened,
  CtaTapToOpen,
  CtaUpgradeToOpen,
  MissedIcon,
  ProgressCircle,
  ReadyIcon,
} from './card-parts'

export function OtherCard(props: {
  card: DayCard
  claimingProgressId?: number | null
  onClaim?: (progressId: number) => void
  onUpgrade?: () => void
  onReturnToToday?: () => void
}) {
  const isInSubscription = useStore($isInSubscription)
  const state = () => props.card.free.state
  const circleState = () => {
    const s = state()
    if (s === 'opened' || s === 'finish') return 'complete'
    if (s === 'up-next') return 'empty'
    return 'in-progress'
  }
  const isClaiming = (id: number | null) =>
    id !== null &&
    props.claimingProgressId !== undefined &&
    props.claimingProgressId === id

  const claimFree = () => {
    if (props.card.free.progressId !== null) {
      props.onClaim?.(props.card.free.progressId)
    }
  }
  const claimPlus = () => {
    if (props.card.plus.progressId !== null) {
      props.onClaim?.(props.card.plus.progressId)
    }
  }

  return (
    <CardShell variant="other">
      <CardHeader
        day={props.card.day}
        countdown={props.card.countdown}
        onReturnToToday={props.onReturnToToday}
      />

      <div class="flex items-center gap-4 self-stretch pl-3">
        <ProgressCircle
          progress={state() === 'up-next' ? 0 : props.card.free.progress}
          goal={props.card.free.target}
          state={circleState()}
          hideValue={state() === 'up-next'}
        />

        <div class="flex h-full min-w-0 flex-1 items-center justify-end self-stretch">
          <Show when={state() === 'finish' || state() === 'opened'}>
            <div class="flex w-full flex-col items-center justify-center gap-3">
              <Show
                when={state() === 'opened'}
                fallback={
                  <CtaTapToOpen
                    loading={isClaiming(props.card.free.progressId)}
                    onClick={claimFree}
                  />
                }
              >
                <CtaOpened />
              </Show>
              <Show
                when={props.card.plus.state === 'opened'}
                fallback={
                  <CtaUpgradeToOpen
                    loading={isClaiming(props.card.plus.progressId)}
                    onUpgrade={props.onUpgrade}
                    onClaim={
                      isInSubscription() && props.card.plus.state === 'finish'
                        ? claimPlus
                        : undefined
                    }
                  />
                }
              >
                <CtaOpened />
              </Show>
            </div>
          </Show>
          <Show when={state() === 'up-next'}>
            <div class="flex w-[166px] flex-col items-center justify-center gap-2">
              <ReadyIcon />
              <span class="text-sm leading-5 text-bakery-brown-soft">
                {m.up_next()}
              </span>
            </div>
          </Show>
          <Show when={state() === 'missed'}>
            <div class="flex w-[166px] flex-col items-center justify-center gap-2">
              <MissedIcon />
              <span class="text-sm leading-5 text-bakery-brown-soft">
                {m.missed_it()}
              </span>
            </div>
          </Show>
        </div>
      </div>
    </CardShell>
  )
}
